export default "__VITE_ASSET__bsl570AB__"